import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Reach from "./sections/Reach";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Consultation />
      <Reach />
      <Inquiries />
      <Footer />
    </div>;
}